
import { requiredRule } from '@/helpers/validation/requiredRule';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PriceInput from '../PriceInput.vue';
import SwitchedContainer from './containers/SwitchedContainer.vue';

interface ValueModel {
    enabled: boolean;
    price: number | null;
}

@Component({
    components: {
        SwitchedContainer,
        PriceInput,
    },
})
export default class SwitchedPriced extends Vue {
    @Prop({ type: String, required: true })
    label!: string;

    @Prop({ type: String, default: '' })
    description!: string;

    @Prop({ type: String, required: false, default: '' })
    priceLabel!: string;

    @Prop({ type: Object, required: true })
    value!: ValueModel;

    @Prop({ type: Boolean, default: false })
    grouped!: boolean;

    currentValue: ValueModel = null as unknown as ValueModel;

    get priceRules() {
        return this.currentValue.enabled && [requiredRule] || [];
    }

    created() {
        this.currentValue = this.value;
    }

    @Watch('currentValue', { deep: true })
    onCurrentValueChange() {
        if (
            this.currentValue.enabled !== this.value.enabled ||
            this.currentValue.price !== this.value.price
        ) {
            this.$emit('input', { ...this.currentValue });
        }
    }

    validate() {
        console.log('validate kurwa');
        return (this.$refs.price as any).validate();
    }

    @Watch('value', { deep: true })
    onValueChange() {
        if (
            this.currentValue.enabled !== this.value.enabled ||
            this.currentValue.price !== this.value.price
        ) {
            this.currentValue = { ...this.value };
        }
    }
}
